var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#4DA2FF",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.201 7.225a2.781 2.781 0 0 1-.017 3.502l-.034.042-.01-.054c-.007-.044-.017-.09-.027-.136-.195-.86-.836-1.597-1.892-2.196-.711-.401-1.12-.886-1.227-1.436a2.088 2.088 0 0 1 .08-1.02c.1-.306.248-.562.372-.715l.41-.5a.18.18 0 0 1 .28 0L10.2 7.226Zm.648-.5L8.1 3.382a.132.132 0 0 0-.203 0l-2.75 3.345-.01.012a3.63 3.63 0 0 0-.806 2.283c0 2.013 1.643 3.646 3.667 3.646s3.666-1.633 3.666-3.646c0-.864-.303-1.657-.809-2.283l-.007-.012Zm-5.043.49.244-.3.008.057c.005.043.012.087.022.131.159.83.728 1.524 1.677 2.06.826.467 1.305 1.005 1.444 1.596.059.246.069.49.044.701l-.002.012-.012.005c-.372.18-.792.282-1.235.282a2.803 2.803 0 0 1-2.81-2.794c0-.662.231-1.273.62-1.75Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSui);
export default __webpack_public_path__ + "static/media/sui.af1875d2fd0863f711c1a32c9e24c628.svg";
export { ForwardRef as ReactComponent };